import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import colors from "styles/colors";
import history from "services/history";
import { NavLink as RNavLink } from "react-router-dom";

const Container = styled.div`
  width: 150px;
  max-width: 150px;
  height: 100%;
  box-shadow: 4px 0px 18px -10px rgba(0, 0, 0, 0.35);
  background: var(--nav-bg);
  display: ${({ connected }) => {
    return connected ? "flex" : "none";
  }};
  flex-direction: column;
`;

const Header = styled.div`
  width: 100%;
  padding: 1px;
  font-weight: bold;
  font-size: 14px;
  color: ${colors.playgroundGreen};
  text-align: center;
`;

const Logout = styled.button`
  border: none;
  background: transparent;
  color: var(--text-color);
  font-weight: bold;
  width: 100%;
  text-align: center;
  cursor: pointer;
`;

const ThemeToggle = styled.button`
  margin: 12px;
  padding: 8px 10px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--button-bg);
  color: var(--button-text);
  cursor: pointer;
  box-shadow: var(--button-shadow);
  font-weight: 700;
`;

const Links = styled.div`
  display: flex;
  padding-left: 20px;
  margin-top: 40px;
  flex-direction: column;
  flex: 1;
  & > * {
    margin-bottom: 15px;
  }
  overflow-y: auto;
`;


const NavLink = styled(RNavLink)`
  color: inherit;
  text-decoration: none;
  border-radius: 8px 0 0 8px;
  padding: 6px 8px;
  &:hover {
    color: inherit;
    background: var(--link-hover-bg);
  }
  &.active {
    font-weight: bold;
    background: var(--link-hover-bg);
    &:hover {
      text-decoration: none;
    }
  }
`;

class LeftNav extends React.Component {
  render() {
    return (
      <Container connected={this.props.connected}>
        <Header>playground</Header>
        <Logout onClick={this.props.logout}>Logout</Logout>
        <ThemeToggle onClick={this.props.onToggleTheme}>
          {this.props.isDarkMode ? "Light mode" : "Dark mode"}
        </ThemeToggle>

        <Links>
          <NavLink to="/categories">Categories</NavLink>
          <NavLink to="/activities">Activities</NavLink>
          <NavLink to="/users">Users</NavLink>
          <NavLink to="/first_users">First users</NavLink>
          <NavLink to="/users_info">Users Info</NavLink>
          <NavLink to="/waiting_list">Waiting List</NavLink>
          <NavLink to="/delete_list">Delete List</NavLink>
          <NavLink to="/referrer_users">Referrer users</NavLink>
          <NavLink to="/access_codes">Access codes</NavLink>
          <NavLink to="/push_notifications">Push notifications</NavLink>
          <NavLink to="/ai_meetups">AI meetups</NavLink>
          <NavLink to="/intent_flow">Future plans</NavLink>
          <NavLink to="/live_intent_flow">Live availability</NavLink>
          <NavLink to="/running_routes">Running routes</NavLink>
          <NavLink to="/admins">Admins</NavLink>
          <NavLink to="/london">London</NavLink>
          <NavLink to="/paris">Paris</NavLink>
          <NavLink to="/dubai">Dubai</NavLink>
          <NavLink to="/madrid">Madrid</NavLink>
          <NavLink to="/new_york">New York</NavLink>
          <NavLink to="/tel_aviv">Tel Aviv</NavLink>
          <NavLink to="/lisbon">Lisbon</NavLink>
          <NavLink to="/brussels">Brussels</NavLink>
          <NavLink to="/rio">Rio</NavLink>
          <NavLink to="/beirut">Beirut</NavLink>
          <NavLink to="/milan">Milan</NavLink>
          <NavLink to="/roma">Roma</NavLink>
          <NavLink to="/athens">Athens</NavLink>
          <NavLink to="/amsterdam">Amsterdam</NavLink>
          <NavLink to="/barcelona">Barcelona</NavLink>
          <NavLink to="/berlin">Berlin</NavLink>
          <NavLink to="/mykonos">Mykonos</NavLink>
          <NavLink to="/app_settings">App settings</NavLink>
        </Links>
      </Container>
    );
  }
}

const mapStateToProps = state => ({ connected: !!state.auth.token });
const mapDispatchToProps = dispatch => ({
  logout: () => {
    dispatch({ type: "LOGOUT" });
    history.push("/login");
  }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { pure: false }
)(LeftNav);
